import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import TeacherView from '../../components/teacher-view/index';
import { getProductTeachers } from '../teacher-roll/actions';
import {
    getTeacherAuthTokenRequest
} from './actions';
import { getLocale } from './../../i18n';
import { teacherUserTypeId } from '../../constants';

class TeacherViewContainer extends Component {
    constructor(props) {
        super(props);
        this.state = { selectedTeacherId: '-1' };
    }

    componentDidMount() {
        const { teachers, selectedProduct } = this.props;
        if (!teachers.length) {
            this.props.getProductTeachers(selectedProduct.id);
        }
    }

    handleOnLaunch = () => {
        const { authToken, selectedProduct, teacherJWTToken } = this.props;
        const config = window.pppAppConfig;
        const tStamp = new Date().getTime();
        if (config && config.portalUrl) {
            const portalUrl = `${config.portalUrl}${authToken}&tstamp=${tStamp}&lang=${getLocale()}&productId=${selectedProduct.id}&JWT=${teacherJWTToken}`;
            window.open(portalUrl, '_blank');
        }
    }

    onTeacherSelectionChange = (name, value) => {
        this.setState({ selectedTeacherId: value });

        if (value !== '-1') {
            this.props.getTeacherAuthTokenRequest(teacherUserTypeId, Number(value));
        }
    }

    render() {
        return (<TeacherView
            handleOnLaunch={this.handleOnLaunch}
            onTeacherSelection={this.onTeacherSelectionChange}
            selectedTeacherId={this.state.selectedTeacherId}
            {...this.props} />);
    }
}

TeacherViewContainer.propTypes = {
    selectedProduct: PropTypes.object,
    teachers: PropTypes.array,
    getProductTeachers: PropTypes.func,
    isTeachersLoaded: PropTypes.bool,
    getTeacherAuthTokenRequest: PropTypes.func,
    authToken: PropTypes.string,
    teacherJWTToken: PropTypes.string,
    isGettingToken: PropTypes.bool
};

const mapStateToProps = state => ({
    selectedProduct: state.product,
    teachers: state.teacherView.teachers,
    isTeachersLoaded: state.teacherView.isTeachersLoaded,
    authToken: state.teacherView.authToken,
    teacherJWTToken: state.teacherView.teacherJWTToken,
    isGettingToken: state.teacherView.isGettingToken
});

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        getProductTeachers,
        getTeacherAuthTokenRequest
    }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(TeacherViewContainer);



// WEBPACK FOOTER //
// ./app/containers/teacher-view/index.js